import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useSession } from "@/hooks/use-session";
import { AdminPartnersPage } from "@/components/admin/AdminPartnersPage";

export const Route = createFileRoute("/admin/partners")({
  validateSearch: () => ({}),
  component: PartnersRoute,
  head: () => ({
    meta: [{ title: "Partners & Referidos — Admin" }],
  }),
});

function PartnersRoute() {
  const { user, isLoading } = useSession();
  if (isLoading) return null;
  if (!user || user.role !== "super_admin") {
    return <Navigate to="/acceso/comercio" search={{ returnTo: "/admin/partners" }} replace />;
  }
  return <AdminPartnersPage />;
}
